import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import CmsContainer from '~/client/shared/cms/CmsContainer';

const CmsContent = styled(CmsContainer)`
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  [id]::before {
    content: '';
    display: block;
    height: 100px;
    margin-top: -100px;
    visibility: hidden;
  }
  p {
    margin-top: 0;
    color: ${({ theme }) => theme.color.bulma[100]};
    margin-bottom: ${rem(16)};
    font-size: ${rem(16)};
    line-height: ${rem(24)};
  }
  span,
  li {
    color: ${({ theme }) => theme.color.bulma[100]}!important;
  }
  a {
    color: ${({ theme }) => theme.color.piccolo[100]};
  }
  .bottom_cta_block {
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: ${rem(12)};
    grid-column-gap: ${rem(16)};
  }
  .cta_item {
    padding: ${rem(20)};
    background: ${({ theme }) => theme.color.gohan[100]};
    border-radius: ${rem(8)};
  }
  .cta_item_title {
    margin: 0 0 ${rem(8)};
    font-size: ${rem(16)};
    line-height: ${rem(24)};
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
  }
  .cta_item_text {
    margin: 0 0 ${rem(12)};
    font-size: ${rem(12)};
    line-height: ${rem(16)};
  }
  .cta_item_link {
    display: inline-block;
  }
  .cta_item_button {
    display: grid;
    grid-gap: ${rem(12)};
    grid-auto-flow: column;
    justify-content: start;
    border: none;
    &,
    a {
      padding: 0 ${rem(16)};
      line-height: ${rem(40)};
      text-align: center;
      min-width: ${rem(96)};
      height: ${rem(40)};
      border-radius: ${rem(40)};
      text-decoration: none;
      font-size: ${rem(14)};
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
      background-color: ${({ theme }) => theme.color.piccolo[100]};
      color: ${({ theme }) => theme.color.goten[100]};
      &:hover {
        background-color: ${({ theme }) => theme.color.piccolo[80]};
      }
      &:active {
        background-color: ${({ theme }) => theme.color.piccolo[120]};
      }
    }
  }
`;

export default CmsContent;
